/**
 * The Insurance Provider picker's filter (OnboardingWizard → InsurerPicker).
 *
 * Every word the patient types must appear somewhere in the insurer's name,
 * short name, aliases or province, in any order, ignoring case and
 * punctuation — so "blue cr", "cross blue" and "GSC" (an alias of Green
 * Shield Canada, the abbreviation on its cards) all land. The picker used to
 * test name/short_name/province with a single `.includes()`, which missed the
 * last two (case imp_33cd2caa).
 *
 * The SAME rule as insurer_matches() in bridge/routers/lookups.py, which
 * serves the list this filters; tests/bridge/test_lookups_insurer_search.py and
 * insurerFilter.test.ts carry the same cases. Change both or neither.
 */

export interface InsurerRow {
  name: string;
  short_name?: string;
  province?: string | null;
  type?: string;
  aliases?: string[];
}

function tokens(s: string): string[] {
  return s.toLowerCase().match(/[a-z0-9]+/g) || [];
}

export function insurerMatches(row: InsurerRow, query: string): boolean {
  const words = tokens(query);
  if (words.length === 0) return true;
  const hay = tokens(
    [row.name, row.short_name || "", row.province || "", ...(row.aliases || [])].join(" "),
  ).join(" ");
  return words.every((w) => hay.includes(w));
}

export function filterInsurers<T extends InsurerRow>(rows: T[], query: string): T[] {
  return rows.filter((r) => insurerMatches(r, query));
}
